export default {
  "products-for-installers": "Solutions pour pros",
  "find-clients": "Nouveaux clients",
  administration: "Gestion administrative",
  "digital-sales-tools": "Études en ligne",
  "resale-agreements": "Contrats d'achat",
  resources: "Ressources",
  blog: "Tous les articles",
  documentation: "Documentation pro",
  guide: "Guide solaire",
  "support-centre": "Support client",
  partners: "Partenariats",
  enterprise: "Entreprise",
  home: "Notre activité",
  "about-us": "Nous connaître",
  "company-values": "Notre engagement",
  pricing: "Tarification",
  newsletter: "Bulletin de projetsolaire",
  "subscribe-newsletter":
    "Actualités, mises à jour, exclusivités : soyez au premier rang.",
  "your-email": "Votre email",
  copyright: `${new Date().getFullYear()} © projetsolaire. Tous droits réservés.`,
  "terms-and-conditions": "Mentions légales",
  "privacy-policy": "Déclaration de Confidentialité",
  "contact-us": "Contact",
  press: "Presse",
  technology: "Technologie",
  careers: "Carrières",
  ambassadors: "Ambassadeurs",
}
